/**
 * @generated SignedSource<<a1109f6a2b24fe65d83169ee02f56ec6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AccountDetailPage_viewer$data = {
  readonly id: string;
  readonly name: string | null;
  readonly email: string;
  readonly company: string | null;
  readonly tel: string | null;
  readonly itpUrls: string | null;
  readonly userTag: string | null;
  readonly role: UserRole;
  readonly isCrossDomainQuery: boolean;
  readonly isCrossDomainFragment: boolean;
  readonly jsTagManagementEnabled: boolean;
  readonly enableBackendUrlMapping: boolean;
  readonly sites: {
    readonly nodes: ReadonlyArray<{
      readonly slug: string;
    } | null> | null;
  };
  readonly " $fragmentType": "AccountDetailPage_viewer";
};
export type AccountDetailPage_viewer = AccountDetailPage_viewer$data;
export type AccountDetailPage_viewer$key = {
  readonly " $data"?: AccountDetailPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountDetailPage_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountDetailPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itpUrls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCrossDomainQuery",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCrossDomainFragment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jsTagManagementEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableBackendUrlMapping",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "SiteConnection",
      "kind": "LinkedField",
      "name": "sites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Site",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "sites(first:1)"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "672efe7bf0fc5e14bc7b54fdb3fca9ff";

export default node;
